import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { createFeedbackBlock } from './feedback';
import { colors } from 'styles/variables';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import Correct_default from 'assets/Correct_loop.gif'; // Correct_default.svg';
import Incorrect_default from 'assets/Incorrect_loop.gif'; // Incorrect_default.svg';
import uuid from 'uuidv4';
import { getSId } from '../utils';

const { lPink, lGrey0, lGrey2, lTeal0 } = colors;

export type SortationInteractionProps = InteractionProps & {
  answerCount: number;
};

// - Sortation
//         - SortationContainer
//           - Text
//           - SortationAnswers
//             - SortationAnswer (repeat)
//               - Text
//           - Text
//         - Button
//         - Feedback (correct)
//           - Image
//           - Text
//           - Button
//         - Feedback (incorrect)
//           - Image
//           - Text
//           - Button

const createSortationContainerBlock = (count: number) => {
  return createBlock('SortationContainer', [
    createBlock('Text'),
    createBlock('SortationAnswers', [
      ...repeat(
        () => createBlock('SortationAnswer', [createBlock('Text')]),
        count
      ),
    ]),
    createBlock('Text'),
  ]);
};

const createSortationFeedbackBlock = type => {
  return createBlock(
    'Feedback',
    [
      createBlock('Image', [], {
        props: {
          src: type === 'Correct' ? Correct_default : Incorrect_default,
        },
      }),
      createBlock('Text'),
      createEditableBtn({ label: 'Continue' }),
    ],
    {
      props: {
        type,
      },
    }
  );
};

// updated / refactored
// export const createSortationBlock = (count: number) => {
//   return createBlock('Sortation', [
//     createSortationContainerBlock(count),
//     createEditableBtn({ label: 'Submit' }),
//     createSortationFeedbackBlock('Correct'),
//     createSortationFeedbackBlock('Incorrect'),
//   ]);
// };

export const createSortationBlock = (count: number) => {
  return createBlock('Sortation', [
    createBlock('SortationHeading0', [createBlock('Text')]),
    createBlock('SortationHeading1', [createBlock('Text')]),
    createEditableBtn({ label: 'Submit' }),
    ...repeat(() => createBlock('Answer', [createBlock('Text')]), count),
  ]);
};

const contentForColumn = (count: number) => (i: number) => {
  // return [() => createBlock('Text'), () => createSortationBlockWithText(count)][
  //   i
  // ];
  return [() => createBlock('Text', []), () => createSortationBlock(count)][i];
};

export const addSortationOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'Sortation') {
    const sortationOptionBlock = createBlock('Answer', [createBlock('Text')]);

    const sortationOptionBlockRef = {
      id: sortationOptionBlock.id,
      type: 'Ref',
    };
    const [newBlocks] = flatten(sortationOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(
      position,
      0,
      sortationOptionBlockRef
    );

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeSortationOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'Sortation') {
    const sortationOptionBlock = createBlock('Answer', [createBlock('Text')]);
    const [newBlocks] = flatten(sortationOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createSortationInteractionBlock = (
  props: SortationInteractionProps
) => {
  const {
    panelBackground = lPink,
    panelBackgroundDragging = lGrey0,
    textColorDragging = '#fff',
    baseColor = lGrey2,
    numberOfAttempts = 1,
    showCorrectAnswer = 0,
    lockDown = 0,
    score = true,
    // scoreValue = 0,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(props.answerCount),
        props.columnCount,
        props.columnsReversed
      ),
      // createBlock('Modal', [createBlock('Text')]),
      createFeedbackBlock({}),
      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            // createBlock('ContinueButton', 'Continue' as any, {
            //   meta: { subType: 'continue' },
            // }),
            createContinueBtn(style),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        panelBackground,
        panelBackgroundDragging,
        textColorDragging,
        baseColor,
        numberOfAttempts,
        showCorrectAnswer,
        lockDown,
        score,
        // scoreValue,
      },
      meta: {
        subType: 'Sortation',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
          }`,
      },
    }
  );
};

export const create = createSortationInteractionBlock;
export const interactionConfig = {};
